/**
* Coverage — 77 จังหวัดของประเทศไทย + 50 เขตกรุงเทพมหานคร
*
* Single source of truth สำหรับหน้า /coverage, sitemap pSEO Phase 2,
* และ AreaServed schema. เก็บทั้งชื่อไทย/อังกฤษ + slug URL-safe เพื่อใช้ต่อ
* ในเฟส pSEO (`/coverage/$province`, `/coverage/bangkok/$district`).
*/
export interface Place {
  slug: string;
  nameTh: string;
  nameEn: string;
  region: "central" | "north" | "northeast" | "east" | "west" | "south" | "bangkok";
}

/** 77 จังหวัด (รวมกรุงเทพฯ) — อ้างอิงกระทรวงมหาดไทย */
export const PROVINCES: Place[] = [
  // Bangkok + Central
  { slug: "bangkok", nameTh: "กรุงเทพมหานคร", nameEn: "Bangkok", region: "bangkok" },
  { slug: "nonthaburi", nameTh: "นนทบุรี", nameEn: "Nonthaburi", region: "central" },
  { slug: "pathum-thani", nameTh: "ปทุมธานี", nameEn: "Pathum Thani", region: "central" },
  { slug: "samut-prakan", nameTh: "สมุทรปราการ", nameEn: "Samut Prakan", region: "central" },
  { slug: "samut-sakhon", nameTh: "สมุทรสาคร", nameEn: "Samut Sakhon", region: "central" },
  { slug: "samut-songkhram", nameTh: "สมุทรสงคราม", nameEn: "Samut Songkhram", region: "central" },
  { slug: "nakhon-pathom", nameTh: "นครปฐม", nameEn: "Nakhon Pathom", region: "central" },
  { slug: "ayutthaya", nameTh: "พระนครศรีอยุธยา", nameEn: "Phra Nakhon Si Ayutthaya", region: "central" },
  { slug: "ang-thong", nameTh: "อ่างทอง", nameEn: "Ang Thong", region: "central" },
  { slug: "lop-buri", nameTh: "ลพบุรี", nameEn: "Lopburi", region: "central" },
  { slug: "sing-buri", nameTh: "สิงห์บุรี", nameEn: "Sing Buri", region: "central" },
  { slug: "chai-nat", nameTh: "ชัยนาท", nameEn: "Chai Nat", region: "central" },
  { slug: "saraburi", nameTh: "สระบุรี", nameEn: "Saraburi", region: "central" },
  { slug: "nakhon-nayok", nameTh: "นครนายก", nameEn: "Nakhon Nayok", region: "central" },
  { slug: "suphan-buri", nameTh: "สุพรรณบุรี", nameEn: "Suphan Buri", region: "central" },
  { slug: "phetchabun", nameTh: "เพชรบูรณ์", nameEn: "Phetchabun", region: "central" },
  // North
  { slug: "chiang-mai", nameTh: "เชียงใหม่", nameEn: "Chiang Mai", region: "north" },
  { slug: "chiang-rai", nameTh: "เชียงราย", nameEn: "Chiang Rai", region: "north" },
  { slug: "lampang", nameTh: "ลำปาง", nameEn: "Lampang", region: "north" },
  { slug: "lamphun", nameTh: "ลำพูน", nameEn: "Lamphun", region: "north" },
  { slug: "mae-hong-son", nameTh: "แม่ฮ่องสอน", nameEn: "Mae Hong Son", region: "north" },
  { slug: "nan", nameTh: "น่าน", nameEn: "Nan", region: "north" },
  { slug: "phayao", nameTh: "พะเยา", nameEn: "Phayao", region: "north" },
  { slug: "phrae", nameTh: "แพร่", nameEn: "Phrae", region: "north" },
  { slug: "uttaradit", nameTh: "อุตรดิตถ์", nameEn: "Uttaradit", region: "north" },
  { slug: "tak", nameTh: "ตาก", nameEn: "Tak", region: "north" },
  { slug: "sukhothai", nameTh: "สุโขทัย", nameEn: "Sukhothai", region: "north" },
  { slug: "phitsanulok", nameTh: "พิษณุโลก", nameEn: "Phitsanulok", region: "north" },
  { slug: "kamphaeng-phet", nameTh: "กำแพงเพชร", nameEn: "Kamphaeng Phet", region: "north" },
  { slug: "phichit", nameTh: "พิจิตร", nameEn: "Phichit", region: "north" },
  { slug: "nakhon-sawan", nameTh: "นครสวรรค์", nameEn: "Nakhon Sawan", region: "north" },
  { slug: "uthai-thani", nameTh: "อุทัยธานี", nameEn: "Uthai Thani", region: "north" },
  // Northeast (Isan)
  { slug: "nakhon-ratchasima", nameTh: "นครราชสีมา", nameEn: "Nakhon Ratchasima", region: "northeast" },
  { slug: "buri-ram", nameTh: "บุรีรัมย์", nameEn: "Buri Ram", region: "northeast" },
  { slug: "surin", nameTh: "สุรินทร์", nameEn: "Surin", region: "northeast" },
  { slug: "sisaket", nameTh: "ศรีสะเกษ", nameEn: "Sisaket", region: "northeast" },
  { slug: "ubon-ratchathani", nameTh: "อุบลราชธานี", nameEn: "Ubon Ratchathani", region: "northeast" },
  { slug: "yasothon", nameTh: "ยโสธร", nameEn: "Yasothon", region: "northeast" },
  { slug: "chaiyaphum", nameTh: "ชัยภูมิ", nameEn: "Chaiyaphum", region: "northeast" },
  { slug: "amnat-charoen", nameTh: "อำนาจเจริญ", nameEn: "Amnat Charoen", region: "northeast" },
  { slug: "nong-bua-lam-phu", nameTh: "หนองบัวลำภู", nameEn: "Nong Bua Lam Phu", region: "northeast" },
  { slug: "khon-kaen", nameTh: "ขอนแก่น", nameEn: "Khon Kaen", region: "northeast" },
  { slug: "udon-thani", nameTh: "อุดรธานี", nameEn: "Udon Thani", region: "northeast" },
  { slug: "loei", nameTh: "เลย", nameEn: "Loei", region: "northeast" },
  { slug: "nong-khai", nameTh: "หนองคาย", nameEn: "Nong Khai", region: "northeast" },
  { slug: "maha-sarakham", nameTh: "มหาสารคาม", nameEn: "Maha Sarakham", region: "northeast" },
  { slug: "roi-et", nameTh: "ร้อยเอ็ด", nameEn: "Roi Et", region: "northeast" },
  { slug: "kalasin", nameTh: "กาฬสินธุ์", nameEn: "Kalasin", region: "northeast" },
  { slug: "sakon-nakhon", nameTh: "สกลนคร", nameEn: "Sakon Nakhon", region: "northeast" },
  { slug: "nakhon-phanom", nameTh: "นครพนม", nameEn: "Nakhon Phanom", region: "northeast" },
  { slug: "mukdahan", nameTh: "มุกดาหาร", nameEn: "Mukdahan", region: "northeast" },
  { slug: "bueng-kan", nameTh: "บึงกาฬ", nameEn: "Bueng Kan", region: "northeast" },
  // East
  { slug: "chachoengsao", nameTh: "ฉะเชิงเทรา", nameEn: "Chachoengsao", region: "east" },
  { slug: "prachin-buri", nameTh: "ปราจีนบุรี", nameEn: "Prachin Buri", region: "east" },
  { slug: "sa-kaeo", nameTh: "สระแก้ว", nameEn: "Sa Kaeo", region: "east" },
  { slug: "chon-buri", nameTh: "ชลบุรี", nameEn: "Chon Buri", region: "east" },
  { slug: "rayong", nameTh: "ระยอง", nameEn: "Rayong", region: "east" },
  { slug: "chanthaburi", nameTh: "จันทบุรี", nameEn: "Chanthaburi", region: "east" },
  { slug: "trat", nameTh: "ตราด", nameEn: "Trat", region: "east" },
  // West
  { slug: "kanchanaburi", nameTh: "กาญจนบุรี", nameEn: "Kanchanaburi", region: "west" },
  { slug: "ratchaburi", nameTh: "ราชบุรี", nameEn: "Ratchaburi", region: "west" },
  { slug: "phetchaburi", nameTh: "เพชรบุรี", nameEn: "Phetchaburi", region: "west" },
  { slug: "prachuap-khiri-khan", nameTh: "ประจวบคีรีขันธ์", nameEn: "Prachuap Khiri Khan", region: "west" },
  // South
  { slug: "chumphon", nameTh: "ชุมพร", nameEn: "Chumphon", region: "south" },
  { slug: "ranong", nameTh: "ระนอง", nameEn: "Ranong", region: "south" },
  { slug: "surat-thani", nameTh: "สุราษฎร์ธานี", nameEn: "Surat Thani", region: "south" },
  { slug: "phang-nga", nameTh: "พังงา", nameEn: "Phang Nga", region: "south" },
  { slug: "phuket", nameTh: "ภูเก็ต", nameEn: "Phuket", region: "south" },
  { slug: "krabi", nameTh: "กระบี่", nameEn: "Krabi", region: "south" },
  { slug: "nakhon-si-thammarat", nameTh: "นครศรีธรรมราช", nameEn: "Nakhon Si Thammarat", region: "south" },
  { slug: "trang", nameTh: "ตรัง", nameEn: "Trang", region: "south" },
  { slug: "phatthalung", nameTh: "พัทลุง", nameEn: "Phatthalung", region: "south" },
  { slug: "satun", nameTh: "สตูล", nameEn: "Satun", region: "south" },
  { slug: "songkhla", nameTh: "สงขลา", nameEn: "Songkhla", region: "south" },
  { slug: "pattani", nameTh: "ปัตตานี", nameEn: "Pattani", region: "south" },
  { slug: "yala", nameTh: "ยะลา", nameEn: "Yala", region: "south" },
  { slug: "narathiwat", nameTh: "นราธิวาส", nameEn: "Narathiwat", region: "south" },
];

/** 50 เขตของกรุงเทพมหานคร */
export const BANGKOK_DISTRICTS: { slug: string; nameTh: string; nameEn: string }[] = [
  { slug: "phra-nakhon", nameTh: "พระนคร", nameEn: "Phra Nakhon" },
  { slug: "dusit", nameTh: "ดุสิต", nameEn: "Dusit" },
  { slug: "nong-chok", nameTh: "หนองจอก", nameEn: "Nong Chok" },
  { slug: "bang-rak", nameTh: "บางรัก", nameEn: "Bang Rak" },
  { slug: "bang-khen", nameTh: "บางเขน", nameEn: "Bang Khen" },
  { slug: "bang-kapi", nameTh: "บางกะปิ", nameEn: "Bang Kapi" },
  { slug: "pathum-wan", nameTh: "ปทุมวัน", nameEn: "Pathum Wan" },
  { slug: "pom-prap-sattru-phai", nameTh: "ป้อมปราบศัตรูพ่าย", nameEn: "Pom Prap Sattru Phai" },
  { slug: "phra-khanong", nameTh: "พระโขนง", nameEn: "Phra Khanong" },
  { slug: "min-buri", nameTh: "มีนบุรี", nameEn: "Min Buri" },
  { slug: "lat-krabang", nameTh: "ลาดกระบัง", nameEn: "Lat Krabang" },
  { slug: "yan-nawa", nameTh: "ยานนาวา", nameEn: "Yan Nawa" },
  { slug: "samphanthawong", nameTh: "สัมพันธวงศ์", nameEn: "Samphanthawong" },
  { slug: "phaya-thai", nameTh: "พญาไท", nameEn: "Phaya Thai" },
  { slug: "thon-buri", nameTh: "ธนบุรี", nameEn: "Thon Buri" },
  { slug: "bangkok-yai", nameTh: "บางกอกใหญ่", nameEn: "Bangkok Yai" },
  { slug: "huai-khwang", nameTh: "ห้วยขวาง", nameEn: "Huai Khwang" },
  { slug: "khlong-san", nameTh: "คลองสาน", nameEn: "Khlong San" },
  { slug: "taling-chan", nameTh: "ตลิ่งชัน", nameEn: "Taling Chan" },
  { slug: "bangkok-noi", nameTh: "บางกอกน้อย", nameEn: "Bangkok Noi" },
  { slug: "bang-khun-thian", nameTh: "บางขุนเทียน", nameEn: "Bang Khun Thian" },
  { slug: "phasi-charoen", nameTh: "ภาษีเจริญ", nameEn: "Phasi Charoen" },
  { slug: "nong-khaem", nameTh: "หนองแขม", nameEn: "Nong Khaem" },
  { slug: "rat-burana", nameTh: "ราษฎร์บูรณะ", nameEn: "Rat Burana" },
  { slug: "bang-phlat", nameTh: "บางพลัด", nameEn: "Bang Phlat" },
  { slug: "din-daeng", nameTh: "ดินแดง", nameEn: "Din Daeng" },
  { slug: "bueng-kum", nameTh: "บึงกุ่ม", nameEn: "Bueng Kum" },
  { slug: "sathon", nameTh: "สาทร", nameEn: "Sathon" },
  { slug: "bang-sue", nameTh: "บางซื่อ", nameEn: "Bang Sue" },
  { slug: "chatuchak", nameTh: "จตุจักร", nameEn: "Chatuchak" },
  { slug: "bang-kho-laem", nameTh: "บางคอแหลม", nameEn: "Bang Kho Laem" },
  { slug: "prawet", nameTh: "ประเวศ", nameEn: "Prawet" },
  { slug: "khlong-toei", nameTh: "คลองเตย", nameEn: "Khlong Toei" },
  { slug: "suan-luang", nameTh: "สวนหลวง", nameEn: "Suan Luang" },
  { slug: "chom-thong", nameTh: "จอมทอง", nameEn: "Chom Thong" },
  { slug: "don-mueang", nameTh: "ดอนเมือง", nameEn: "Don Mueang" },
  { slug: "ratchathewi", nameTh: "ราชเทวี", nameEn: "Ratchathewi" },
  { slug: "lat-phrao", nameTh: "ลาดพร้าว", nameEn: "Lat Phrao" },
  { slug: "watthana", nameTh: "วัฒนา", nameEn: "Watthana" },
  { slug: "bang-khae", nameTh: "บางแค", nameEn: "Bang Khae" },
  { slug: "lak-si", nameTh: "หลักสี่", nameEn: "Lak Si" },
  { slug: "sai-mai", nameTh: "สายไหม", nameEn: "Sai Mai" },
  { slug: "khan-na-yao", nameTh: "คันนายาว", nameEn: "Khan Na Yao" },
  { slug: "saphan-sung", nameTh: "สะพานสูง", nameEn: "Saphan Sung" },
  { slug: "wang-thonglang", nameTh: "วังทองหลาง", nameEn: "Wang Thonglang" },
  { slug: "khlong-sam-wa", nameTh: "คลองสามวา", nameEn: "Khlong Sam Wa" },
  { slug: "bang-na", nameTh: "บางนา", nameEn: "Bang Na" },
  { slug: "thawi-watthana", nameTh: "ทวีวัฒนา", nameEn: "Thawi Watthana" },
  { slug: "thung-khru", nameTh: "ทุ่งครุ", nameEn: "Thung Khru" },
  { slug: "bang-bon", nameTh: "บางบอน", nameEn: "Bang Bon" },
];

export function provincesByRegion() {
  const map = new Map<Place["region"], Place[]>();
  for (const p of PROVINCES) {
    if (!map.has(p.region)) map.set(p.region, []);
    map.get(p.region)!.push(p);
  }
  return map;
}

export const REGION_LABEL: Record<Place["region"], string> = {
  bangkok: "กรุงเทพมหานคร",
  central: "ภาคกลาง",
  north: "ภาคเหนือ",
  northeast: "ภาคตะวันออกเฉียงเหนือ (อีสาน)",
  east: "ภาคตะวันออก",
  west: "ภาคตะวันตก",
  south: "ภาคใต้",
};
